import component from './manageUsers.vue';
export const MANAGE_USERS = "manageUsers";

export default{
    id: MANAGE_USERS,
    component,
}